import LiModal from "./src/index.vue";

LiModal.install = function (Vue) {
  Vue.component(LiModal.name, LiModal);
};

export default LiModal;
